import React, { forwardRef, InputHTMLAttributes } from "react";
import { RadioboxContainer } from "./styles";

type RadioProps = InputHTMLAttributes<HTMLInputElement> & {
  display?: boolean;
};

export const Radiobox =
  // eslint-disable-next-line react/display-name
  forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
    return (
      <RadioboxContainer display={props.display}>
        <input ref={ref} {...props} type="radio" className="check" />
        <label htmlFor="check" />
      </RadioboxContainer>
    );
  });
